import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { PreviousRoute } from "@nx/mono-common";
import { signInPreviousRouteContext } from "../constants/sign-in.constants";

@Injectable({
  providedIn: 'root'
})

export class ReferrerPageCheckResolver  {
  constructor(private router: Router) { }

  resolve(): boolean {
    return new PreviousRoute(this.router, signInPreviousRouteContext).contextPreviousRouteExistsInRouter();
  }
}